export enum RoutePath {
  Dashboard = 'dashboard',
  Monitoring = 'monitoring',
  AllocationView = 'allocation-view',
}
